





























import { reactive, computed, defineComponent, SetupContext } from '@vue/composition-api';
import { RouteConfig } from 'vue-router';
import MainMenu from './MainMenu.vue';

const Component = defineComponent({
  name: 'Navbar',
  components: {
    MainMenu,
  },

  setup(_, { root }: SetupContext) {
    const state = reactive({
      entityName: computed(() => root.$route.meta?.title),
      entityIcon: computed(() => root.$route.meta?.icon),
      items: computed(() =>
        getRoutes().filter(
          (route: RouteConfig) =>
            route.meta?.isSidebarItem || route.meta?.isSidebarItem === undefined,
        ),
      ),
    });

    function getRoutes() {
      //get children of root path ('/')
      return (root.$router as any).options.routes[0].children;
    }

    function logout() {
      root.$store.dispatch('userModule/logout').then(() => {
        root.$router.push('/login');
      });
    }

    function allowLogout() {
      // allow logout out of iframe
      return window.self === window.top;
    }

    return {
      state,
      logout,
      allowLogout,
    };
  },
});

export default Component;
